export class EnumApiAuth {
    constructor() {
        /**
         * @dec post 企业认证 - token 获取企业认证信息
         */
        this.company_auth_token = {
            url: '/api/gateway/company-cert-bff/api/partnerVerified/token',
            method: 'post',
            loading: true,
            awaitAuthenticated: false,
        };
        /**
         * @method get 根据身份id查询企业身份详情 (新，合并l2后)
         * @params
         */
        this.partner_partnerIdentity_findInfo_new = {
            url: '/api/gateway/partner-bff/v3/api/partnerIdentity/findCurrentPartnerIdentity',
            method: 'get',
            loading: true,
            awaitAuthenticated: true,
        };
        /**
         * @dec 获取用户信息
         * @method get
         * @params
         */
        this.idass_get_userinfo = {
            url: '/api/gateway/idaas/v1/users/user/info/get',
            method: 'get',
            loading: true,
            awaitAuthenticated: false,
        };
        /**
         * @dec 登录后是否需要选择身份
         * @method get
         * @params
         */
        this.accountsvr_identity_ischoose = {
            url: '/api/gateway/idaas/v1/identity/choose/judge',
            method: 'get',
        };
        /**
         * @dec
         * @method post 获取身份list(新，合并l2后)
         * @params
         */
        this.partner_get_partnerIdentity_new = {
            url: '/api/gateway/partner-bff/v3/api/partnerIdentity/listChannelByUserId4Choice',
            method: 'get',
            loading: true,
        };
        /**
         * @dec 根据userId查询渠道意向伙伴的bu
         */
        this.bffsvr_get_partner_by_userid = {
            url: '/api/gateway/partner-bff/public/partner/label/get?userId={userId}',
            method: 'get',
        };
        /**
         * @dec 根据userId查询sales的bu
         */
        this.bffsvr_get_sales_by_userid = {
            url: '/api/gateway/pcsd-bp-customer-usersvr/v2/sales/bu/userId/get?userId={userId}',
            method: 'get',
        };
        /**
         * @dec 根据登陆的地址获取sales的信息
         */
        this.usersvr_salesInfo = {
            url: '/api/gateway/pcsd-bp-customer-usersvr/v2/sales/findByCity',
        };
        /**
         * @dec 退出登录
         */
        this.accountsvr_loginout = {
            url: '/api/gateway/idaas/v1/token/invalid',
            method: 'put',
        };
        /**
         * @des 直播活动  推广记录器
         */
        this.content_live_record = {
            url: '/api/gateway/pcsd-bp-customer-bff-content/public/v1/promotion/record',
            method: 'post',
        };
    }
}
